import { render } from "./AboutManage.vue?vue&type=template&id=b297a848&scoped=true"
import script from "./AboutManage.vue?vue&type=script&lang=js"
export * from "./AboutManage.vue?vue&type=script&lang=js"

import "./AboutManage.vue?vue&type=style&index=0&id=b297a848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b297a848"]])

export default __exports__